import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import DatePicker from 'react-datepicker';

class PaymentOrdersEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.payment_order_id,
      name: this.props.payment_order_data.name,
      code: this.props.payment_order_data.code,
      type: this.props.payment_order_data.type,
      status: this.props.payment_order_data.status,
      status_str: this.props.payment_order_data.status_str,
      official_status: this.props.payment_order_data.status,
      payment_date: this.props.payment_order_data.payment_date_str,
      email_enviado: this.props.payment_order_data.email_enviado,
      status_options: []
    };

    //bind específico
    this.edit = this.edit.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.sendNewMail = this.sendNewMail.bind(this);
    this.sendMailLoading = this.sendMailLoading.bind(this);
    this.sendNewEmailLoading = this.sendNewEmailLoading.bind(this);
  }

  handleChangeDatePicker (state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.payment_order_data.id !== 'undefined' && this.state.loaded === 0) {
      let status_options = [
        {value: "aberto", label: "Prevista"},
        {value: "enviado", label: "Enviada para Aprovação"},
        {value: "aprovado", label: "Aprovada"},
        {value: "agendado", label: "Pagamento Agendado"},
        {value: "pago", label: "Pagamento Efetuado"},
        {value: "cancelada", label: "Cancelada"},
      ];
      if (newProps.payment_order_data.status === 'aberto') {
        status_options = [
          {value: "aberto", label: "Prevista"},
          {value: "enviado", label: "Enviada para Aprovação"},
          {value: "cancelada", label: "Cancelada"},
        ]
      }
      if (newProps.payment_order_data.status === 'enviado') {
        status_options = [
          {value: "enviado", label: "Enviada para Aprovação"},
          {value: "aprovado", label: "Aprovada"},
          {value: "cancelada", label: "Cancelada"},
        ]
      }
      if (newProps.payment_order_data.status === 'aprovado') {
        status_options = [
          {value: "aprovado", label: "Aprovada"},
          {value: "agendado", label: "Pagamento Agendado"},
          {value: "cancelada", label: "Cancelada"},
        ]
      }
      if (newProps.payment_order_data.status === 'agendado') {
        status_options = [
          {value: "agendado", label: "Pagamento Agendado"},
          {value: "pago", label: "Pagamento Efetuado"},
          {value: "cancelada", label: "Cancelada"},
        ]
      }
      this.setState({
        id: newProps.payment_order_id,
        name: newProps.payment_order_data.name,
        type: newProps.payment_order_data.type,
        code: newProps.payment_order_data.code,
        status: newProps.payment_order_data.status,
        status_str: newProps.payment_order_data.status_str,
        official_status: newProps.payment_order_data.status,
        payment_date: newProps.payment_order_data.payment_date_str,
        email_enviado: newProps.payment_order_data.email_enviado,
        status_options: status_options,
        loaded: 2,
      });
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      code: this.state.code,
      name: this.state.name,
      status: this.state.status,
      payment_date: this.state.payment_date,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/ordem/pagamento', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        if (responseJson.status === 'success') {
          let status_options = [
            {value: "aberto", label: "Prevista"},
            {value: "enviado", label: "Enviada para Aprovação"},
            {value: "aprovado", label: "Aprovada"},
            {value: "agendado", label: "Pagamento Agendado"},
            {value: "pago", label: "Pagamento Efetuado"},
            {value: "cancelada", label: "Cancelada"},
          ];
          if (responseJson.data.status === 'aberto') {
            status_options = [
              {value: "aberto", label: "Prevista"},
              {value: "enviado", label: "Enviada para Aprovação"},
              {value: "cancelada", label: "Cancelada"},
            ]
          }
          if (responseJson.data.status === 'enviado') {
            status_options = [
              {value: "enviado", label: "Enviada para Aprovação"},
              {value: "aprovado", label: "Aprovada"},
              {value: "cancelada", label: "Cancelada"},
            ]
          }
          if ( responseJson.data.status === 'aprovado') {
            status_options = [
              {value: "aprovado", label: "Aprovada"},
              {value: "agendado", label: "Pagamento Agendado"},
              {value: "pago", label: "Pagamento Efetuado"},
              {value: "cancelada", label: "Cancelada"},
            ]
          }
          if ( responseJson.data.status === 'agendado') {
            status_options = [
              {value: "agendado", label: "Pagamento Agendado"},
              {value: "pago", label: "Pagamento Efetuado"},
              {value: "cancelada", label: "Cancelada"},
            ]
          }
          self.setState({official_status: self.state.status, status_str: responseJson.data.status_str, status_options: status_options});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch enviando os e-mails para os usuários
  sendNewEmailLoading(event) {
    event.preventDefault();
    var self = this;
    self.props.handleAlert('Os e-mails estão sendo reenviados. Essa operação pode levar entre 30 a 60 segundos. Em breve iniciaremos o envio.', 'success', 'open');
    setTimeout(function(){
      self.sendNewMail(event);
    }, 3000);
  }
  // Fetch enviando os e-mails para os usuários
  sendMailLoading(event) {
    event.preventDefault();
    var self = this;
    self.props.handleAlert('Os e-mails estão sendo enviados. Essa operação pode levar entre 30 a 60 segundos. Em breve iniciaremos o envio.', 'success', 'open');
    setTimeout(function(){
      self.sendMail(event);
    }, 3000);
  }
  // Fetch enviando os e-mails para os usuários
  sendMail(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var self = this;
    var datasave = {
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/enviar/ordem/pagamento', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          let status_options = [
            {value: "agendado", label: "Pagamento Agendado"},
            {value: "pago", label: "Pagamento Efetuado"},
            {value: "cancelada", label: "Cancelada"},
          ]
          self.setState({email_enviado: 1, official_status: responseJson.data.status, status_str: responseJson.data.status_str, status: responseJson.data.status, status_options: status_options});
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        } else {
          self.props.listErrors(responseJson);
        }
      })
    });
  }

  // Fetch enviando os e-mails para os usuários que nao foram pagos
  sendNewMail(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var self = this;
    var datasave = {
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/reenviar/ordem/pagamento', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({email_enviado: 1});
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        } else {
          self.props.listErrors(responseJson);
        }
      })
    });
  }


  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <form onSubmit={this.edit}>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Nome:</label>
                {(self.state.official_status === 'aberto') ? <input type="text" name="name" className="form-control" placeholder="" value={this.state.name} onChange={this.handleChange.bind(this, 'name')}  /> : <div><strong>{this.state.name}</strong></div>
                }
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Código:</label>
                {(self.state.official_status === 'aberto') ? <input type="text" name="code" disabled="disabled" className="form-control" placeholder="" value={this.state.code} onChange={this.handleChange.bind(this, 'code')} /> : <div><strong>{this.state.code}</strong></div>
                  }
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Status:</label>
                  {(self.state.official_status !== 'pago' && self.state.official_status !== 'cancelada') ?
                    <Select
                      className="form-field-name"
                      name="status"
                      placeholder=""
                      value={this.state.status}
                      searchable={true}
                      onChange={this.handleSelectChange.bind(this, 'status')}
                      options={this.state.status_options}
                    />
                  : <div><strong>{this.state.status_str}</strong></div>
                  }
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Data de pagamento:</label>
                  {(self.state.official_status === 'aprovado' || self.state.official_status === 'agendado') ? <DatePicker value={this.state.payment_date} onChange={this.handleChangeDatePicker.bind(this, 'payment_date')} className="form-control" /> : <div><strong>{this.state.payment_date}</strong></div>
                  }
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <hr/>
                <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar edição</button>
              </div>
            </div>

          </form>
          {
            (self.state.official_status === 'agendado') ?
            (self.state.email_enviado === 1) ?
              <div><hr/><button type="button" className="btn btn-warning btn-lg btn-block btn-inline" onClick={self.sendNewEmailLoading}><i className="fa fa-fw fa-envelope"></i> Reenviar e-mail de pagamento</button></div>
            :
              ''
          :
          ''
          }
          {
            (self.state.official_status === 'aprovado' || self.state.official_status === 'agendado' || self.state.official_status === 'pago') ?
            (self.state.email_enviado === 1) ?
              <div><hr/><button type="button" className="btn btn-info btn-lg btn-block btn-inline" disabled><i className="fa fa-fw fa-envelope"></i> Enviar pagamento</button></div>
            :
              <div><hr/><button type="button" className="btn btn-info btn-lg btn-block btn-inline" onClick={self.sendMailLoading}><i className="fa fa-fw fa-envelope"></i> Enviar pagamento</button></div>
          :
          ''
          }
      </div>
    );
  }
}

export default PaymentOrdersEditTab;



// WEBPACK FOOTER //
// ./src/Components/PaymentOrders/Elements/PaymentOrdersEditTab.js